/**
 * Carlsberg Nepal — Hub Admin API base URL for staging/production builds.
 * Used by api-configuration.ts (all endpoints append paths to this /v1 root).
 */
export const hubAdminStagingApiV1 =
  "https://hubadminapi.carlsbergnepal.bigcityvoucher.co.in/v1";

// LOCAL (docker compose: hubadmin_api) — uncomment for E2E on localhost
// export const hubAdminStagingApiV1 = "http://localhost:8082/v1";
